<template>
  <div class="page-wrapper-table-body">
    <div class="page-wrapper-table-body-inner">
      <div v-if="taxes.length" class="taxes-section">
        <el-table
          class="align-items-center table-flush"
          header-row-class-name="thead-light"
          :data="taxes"
        >
          <el-table-column
            :label="$t('COMMON.NAME')"
            prop="name"
            min-width="350"
          >
            <template v-slot="{ row }">
              <span class="taxe-name">{{ row.name }}</span>
              <em class="taxe-type text-gray">
                - {{ $t("TAXES." + row.calculation_type) }}
              </em>
            </template>
          </el-table-column>
          <el-table-column :label="$t('TAXES.ACTIVE')" min-width="100">
            <template v-slot="{ row }">
              <badge v-if="row.active" type="success">
                {{ $t("TAXES.ACTIVE") }}
              </badge>
              <badge v-else type="secondary">
                {{ $t("TAXES.DEACTIVATED") }}
              </badge>
            </template>
          </el-table-column>
          <el-table-column :label="$t('TAXES.COUT')" min-width="300">
            <template v-slot="{ row }">
              <span v-if="row.calculation_type == typeMontantFixe">{{
                $formatCurrency(row.value)
              }}</span>
              <span v-else-if="row.calculation_type == typePourcentage">{{
                row.value + "%"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" min-width="120">
            <div slot-scope="{ row }" class="table-actions">
              <el-tooltip
                :content="$t('COMMON.VIEW')"
                placement="top"
                v-if="$currentUserCan($permissions.PERM_VIEW_TAXES)"
              >
                <a
                  type="text"
                  @click="viewTax(row)"
                  class="table-action"
                  data-toggle="tooltip"
                  style="cursor: pointer"
                >
                  <i class="fal fa-expand-alt"></i>
                </a>
              </el-tooltip>
            </div>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import { TYPE_POURCENTAGE, TYPE_MONTANT_FIXE } from "@/constants/taxes";
import { QUERY_ACTIONS_VIEW } from "@/constants/common";
import { Table, TableColumn } from "element-ui";

export default {
  name: "TaxesViewTable",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  props: {
    taxes: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      typeMontantFixe: TYPE_MONTANT_FIXE,
      typePourcentage: TYPE_POURCENTAGE,
    };
  },
  methods: {
    viewTax(tax) {
      this.$router.push({
        name: "List Taxes",
        query: { id: tax.id, action: QUERY_ACTIONS_VIEW },
      });
    },
  },
};
</script>

<style scoped>
.taxes-section {
  margin-bottom: 30px;
}
.taxe-type {
  font-size: 11px;
}

.elite-content .resizable-wrapper-content-body .page-wrapper-table-body-inner {
  border: none !important;
}
.elite-content .page-wrapper-table-body-inner {
  display: block !important;
}
</style>
